import axios from 'axios';

export const useFetchCountryStates = async (language: string): Promise<any> => {
    const data = await axios.post(
        `${process.env.DRUPAL_URL}/graphql`,
        {
            query: `query fetchCountryStates($country: String!) {
                        country_states(country: $country) {
                            data
                        }
                    }
            `,
            variables: {
                country: language,
            },
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    const result = JSON.parse(data?.data?.data?.country_states?.data);
    return result ?? {};
};
